import NativeBinder from './libs/NativeBinder';
import SendbirdCallsModule from './libs/SendbirdCallsModule';

export * from './utils/logger';
export * from './types';
export { CallsEvent, DefaultEventType, DirectCallEventType, GroupCallEventType } from './libs/NativeBinder';
export { DirectCall } from './libs/DirectCall';
export { Room } from './libs/Room';
export { Participant, LocalParticipant } from './libs/Participant';
export { DirectCallLogListQuery, RoomListQuery } from './libs/BridgedQuery';
export { SendbirdError } from './libs/SendbirdError';

const nativeBinder = new NativeBinder();
export const SendbirdCalls = new SendbirdCallsModule(nativeBinder);
export { default as DirectCallVideoView, DirectCallVideoViewProps } from './libs/DirectCallVideoView';
export { default as GroupCallVideoView, GroupCallVideoViewProps } from './libs/GroupCallVideoView';
export { default as SendbirdCallsModule } from './libs/SendbirdCallsModule';
